<script>

    import { toast } from 'bulma-toast'

    import StatisticsService from '../$services/statistics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import StatsCard from '../$components/stats.card.svelte'
    import Spinner from '../$components/spinner.svelte'

    export let dateStart = null
    export let dateEnd = null

    let loading = false
    let users = []

    $: if (dateStart && dateEnd)
        getChargesRefundsUsersTop()

    async function getChargesRefundsUsersTop() {
        loading = true
        users = []

        const resp = await StatisticsService.getChargesRefundsUsersTop({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
        })

        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        users = resp.data?.users ?? []
    }

</script>

<style>
    .users-list {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    .users-list__item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.85rem 0;
        border-bottom: 1px solid #eee;
    }

    .users-list__item:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .users-list__item:first-child {
        padding-top: 0;
    }

    .users-list__rank {
        flex-shrink: 0;
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 50%;
        background: #f4f4f4;
        color: #666;
        font-size: 12px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .users-list__info {
        flex: 1;
        min-width: 0;
    }

    .users-list__title {
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0 0 2px;
    }

    .users-list__meta {
        font-size: 12px;
        color: #a0a0a0;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .users-list__total {
        flex-shrink: 0;
        font-size: 15px;
        font-weight: 700;
        color: #c8645c;
    }
</style>

<StatsCard icon="fa-undo" meta="Cargos" title="Top usuarios con más reembolsos" {dateStart} {dateEnd}>
    <div>
        <Spinner {loading} />
        {#if !loading && users.length}
            <ul class="users-list">
                {#each users as user, index}
                    <li class="users-list__item">
                        <span class="users-list__rank">{ index + 1 }</span>
                        <div class="users-list__info">
                            <p class="users-list__title">{ user.name }</p>
                            <p class="users-list__meta">{ user.email }</p>
                        </div>
                        <span class="users-list__total">{ NumeralMethods.cash(user.total) }</span>
                    </li>
                {/each}
            </ul>
        {:else if !loading}
            <p class="empty">Sin datos en el periodo seleccionado</p>
        {/if}
    </div>
</StatsCard>
